// extracted by mini-css-extract-plugin
export default {"quotesList":"QuotesList_quotesList__OhZQf","noQuotes":"QuotesList_noQuotes__jprTK"};